export const ApiHeaderGenerateConfig = Object.freeze({
  region: 'C001',
  keyCloakSid: 'sid',
  trazabilityCode: 'trazabilityCode',
  fingerPrint: 'fingerPrint',
  loginState: 'loginState'
});
